import _slicedToArray from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * Theme.js
 *
 * Theme provides themed colors and strings.
 *
 * Copyright (c) apploft. GmbH
 */
import { createContext, createElement, useContext, useState, useEffect } from 'react';
var ColorContext = createContext({});
var StringContext = createContext({});

function Theme(_ref) {
  var children = _ref.children,
      colors = _ref.colors,
      strings = _ref.strings;
  return createElement(StringContext.Provider, {
    value: strings
  }, [createElement(ColorContext.Provider, {
    value: colors,
    key: 'colors'
  }, children)]);
}
/**
 * Returns `true` if props specify required.
 *
 * @param {{required?: boolean}} props
 */


function isRequired(_ref2) {
  var required = _ref2.required;
  return typeof required === 'boolean' ? required : false;
}
/**
 * Returns string matching `key` or `key`.
 *
 * @param {{}} context The strings context.
 * @param {string} key The key or property name.
 */


function stringMatching(context, key) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!context) {
    return '';
  }

  if (typeof key !== 'string') {
    return '';
  }

  var str = context[key] || context[key.toLowerCase()] || key;

  if (!required) {
    return str;
  }

  return "".concat(str, " *");
}
/**
 * Returns color matching `name` or `red`.
 *
 * @param {{}} context The colors context.
 * @param {string} name The name of the color.
 */


function colorMatching(context, name) {
  return context[name] || '0xff0000';
}

function useStrings() {
  return useContext(StringContext);
} // TODO: Review


function useMedia(queries, values, defaultValue) {
  var mediaQueryLists = queries.map(function (q) {
    return window.matchMedia(q);
  });

  var getValue = function getValue() {
    var index = mediaQueryLists.findIndex(function (mql) {
      return mql.matches;
    });
    return typeof values[index] !== 'undefined' ? values[index] : defaultValue;
  };

  var _useState = useState(getValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    var handler = function handler() {
      return setValue(getValue);
    };

    mediaQueryLists.forEach(function (mql) {
      return mql.addListener(handler);
    });
    return function () {
      return mediaQueryLists.forEach(function (mql) {
        return mql.removeListener(handler);
      });
    };
  }, []);
  return value;
}

function useColors() {
  var theme = useMedia(['(prefers-color-scheme: dark)'], ['dark', 'light'], 'light');
  return useContext(ColorContext)[theme];
}

export { Theme, stringMatching, colorMatching, isRequired, useColors, useStrings };